import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//
import App from "App";
import PageNotFound404 from "Views/PageNotFound404/PageNotFound404";
import DemoPage from "Views/Demo";
import ViewFinalPdf from "Views/ViewFinalPdf";
import InPersonSigningPage from "Views/InPersonSigning";
import SelfSigningPage from "Views/SelfSigning";

const AllRoutes = () => {
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
      <Routes>
        <Route path="/" Component={App} />
        <Route path="/viewFinalPdf" Component={ViewFinalPdf} />
        <Route path="/demo" Component={DemoPage} />
        <Route path="/in-person-signing" Component={InPersonSigningPage} />
        <Route path="/self-signing" Component={SelfSigningPage} />
        <Route path="/page404" Component={PageNotFound404} />
        <Route path="*" Component={PageNotFound404} />
      </Routes>
    </Router>
  );
};

export { AllRoutes };
